/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdDomainSettingsWebRuntimeType } from './FxIdDomainSettingsWebRuntimeType';
import {
    FxIdDomainSettingsWebRuntimeTypeFromJSON,
    FxIdDomainSettingsWebRuntimeTypeFromJSONTyped,
    FxIdDomainSettingsWebRuntimeTypeToJSON,
    FxIdDomainSettingsWebRuntimeTypeToJSONTyped,
} from './FxIdDomainSettingsWebRuntimeType';

/**
 * 
 * @export
 * @interface FxGamesLibWebPlatformDataOptionsWebOptionsWebRuntimesOptions
 */
export interface FxGamesLibWebPlatformDataOptionsWebOptionsWebRuntimesOptions {
    /**
     * 
     * @type {FxIdDomainSettingsWebRuntimeType}
     * @memberof FxGamesLibWebPlatformDataOptionsWebOptionsWebRuntimesOptions
     */
    Default: FxIdDomainSettingsWebRuntimeType;
    /**
     * 
     * @type {Array<FxIdDomainSettingsWebRuntimeType>}
     * @memberof FxGamesLibWebPlatformDataOptionsWebOptionsWebRuntimesOptions
     */
    Supported: Array<FxIdDomainSettingsWebRuntimeType>;
}



/**
 * Check if a given object implements the FxGamesLibWebPlatformDataOptionsWebOptionsWebRuntimesOptions interface.
 */
export function instanceOfFxGamesLibWebPlatformDataOptionsWebOptionsWebRuntimesOptions(value: object): value is FxGamesLibWebPlatformDataOptionsWebOptionsWebRuntimesOptions {
    if (!('Default' in value) || value['Default'] === undefined) return false;
    if (!('Supported' in value) || value['Supported'] === undefined) return false;
    return true;
}

export function FxGamesLibWebPlatformDataOptionsWebOptionsWebRuntimesOptionsFromJSON(json: any): FxGamesLibWebPlatformDataOptionsWebOptionsWebRuntimesOptions {
    return FxGamesLibWebPlatformDataOptionsWebOptionsWebRuntimesOptionsFromJSONTyped(json, false);
}

export function FxGamesLibWebPlatformDataOptionsWebOptionsWebRuntimesOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxGamesLibWebPlatformDataOptionsWebOptionsWebRuntimesOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'Default': FxIdDomainSettingsWebRuntimeTypeFromJSON(json['Default']),
        'Supported': ((json['Supported'] as Array<any>).map(FxIdDomainSettingsWebRuntimeTypeFromJSON)),
    };
}

export function FxGamesLibWebPlatformDataOptionsWebOptionsWebRuntimesOptionsToJSON(json: any): FxGamesLibWebPlatformDataOptionsWebOptionsWebRuntimesOptions {
    return FxGamesLibWebPlatformDataOptionsWebOptionsWebRuntimesOptionsToJSONTyped(json, false);
}

export function FxGamesLibWebPlatformDataOptionsWebOptionsWebRuntimesOptionsToJSONTyped(value?: FxGamesLibWebPlatformDataOptionsWebOptionsWebRuntimesOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Default': FxIdDomainSettingsWebRuntimeTypeToJSON(value['Default']),
        'Supported': ((value['Supported'] as Array<any>).map(FxIdDomainSettingsWebRuntimeTypeToJSON)),
    };
}

